import { SubtotalsListItem } from './SubtotalsListItem';
import * as React from 'react';
import { translate } from 'react-i18next';
export var Subtotal = translate()(function (_a) {
    var subtotal = _a.subtotal, moneyFormatter = _a.moneyFormatter, t = _a.t;
    return (React.createElement(SubtotalsListItem, { dataHook: "subtotal", label: t('quote.form.sub_total'), value: moneyFormatter(subtotal) }));
});
//# sourceMappingURL=Subtotal.js.map